import React from 'react';

export function Terms() {
    return (
        <div className="min-h-screen bg-background py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto prose dark:prose-invert">
                <h1 className="text-3xl font-bold text-foreground mb-8">Terms of Service</h1>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">1. Acceptance of Terms</h2>
                    <p className="text-muted-foreground mb-4">
                        By accessing or using our service, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this service.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">2. Use License</h2>
                    <p className="text-muted-foreground mb-4">
                        Permission is granted to temporarily download one copy of the materials (information or software) on BgRemover for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                    </p>
                    <ul className="list-disc pl-5 text-muted-foreground space-y-2">
                        <li>Modify or copy the materials;</li>
                        <li>Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</li>
                        <li>Attempt to decompile or reverse engineer any software contained on BgRemover's website;</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-foreground mb-4">3. Disclaimer</h2>
                    <p className="text-muted-foreground mb-4">
                        The materials on BgRemover's website are provided on an 'as is' basis. BgRemover makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                    </p>
                </section>

                <div className="pt-8 border-t border-border">
                    <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    );
}
